export default __webpack_public_path__ + "static/media/ayla2.d6aca8bc.jpeg";